import React, { useEffect, useState, useRef } from "react";
import { Box, Typography, CircularProgress, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useFirebase } from "../context/ApiContext";

const VerifyEmailPage = () => {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const { verifyEmail } = useFirebase();
	const [status, setStatus] = useState("loading"); // loading | success | error
	const [errorMsg, setErrorMsg] = useState("");
	const verifiedOnce = useRef(false);

	useEffect(() => {
		const token = searchParams.get("token");
		if (!token) {
			setStatus("error");
			setErrorMsg("No se encontró el token de verificación.");
			return;
		}
		// Evitar múltiples envíos (Strict Mode, re-renders, etc.)
		if (verifiedOnce.current) return;
		verifiedOnce.current = true;

		verifyEmail(token)
			.then(() => setStatus("success"))
			.catch((err) => {
				setStatus("error");
				setErrorMsg(
					err?.response?.data?.message ||
						"El enlace de verificación es inválido o ha expirado."
				);
			});
	}, [searchParams, verifyEmail]);

	return (
		<Box
			sx={{
				minHeight: "100vh",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
				p: 3,
			}}
		>
			<Box
				sx={{
					maxWidth: 440,
					width: "100%",
					textAlign: "center",
					bgcolor: "#fff",
					borderRadius: "24px",
					p: 5,
					boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
				}}
			>
				{status === "loading" && (
					<>
						<CircularProgress size={48} sx={{ color: "#6366F1", mb: 3 }} />
						<Typography
							sx={{
								fontSize: 17,
								fontWeight: 600,
								color: "#334155",
								fontFamily: "'Inter', sans-serif",
							}}
						>
							Verificando tu email...
						</Typography>
					</>
				)}

				{status === "success" && (
					<>
						<Box
							sx={{
								width: 72,
								height: 72,
								borderRadius: "50%",
								background: "linear-gradient(135deg, #D1FAE5 0%, #A7F3D0 100%)",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								mx: "auto",
								mb: 3,
							}}
						>
							<CheckCircleIcon sx={{ fontSize: 40, color: "#059669" }} />
						</Box>
						<Typography
							sx={{
								fontSize: 22,
								fontWeight: 700,
								color: "#1a1a2e",
								mb: 1,
								fontFamily: "'Inter', sans-serif",
							}}
						>
							Email verificado
						</Typography>
						<Typography
							sx={{
								fontSize: 14,
								color: "#64748b",
								mb: 3,
								lineHeight: 1.6,
								fontFamily: "'Inter', sans-serif",
							}}
						>
							Tu cuenta está completamente activada. Ya puedes usar todas las
							funciones de Viajes Molones.
						</Typography>
						<Button
							onClick={() => navigate("/")}
							sx={{
								height: 48,
								borderRadius: "14px",
								background: "linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
								color: "#fff!important",
								textTransform: "none",
								fontWeight: 600,
								fontSize: 14,
								px: 4,
								boxShadow: "0 4px 14px rgba(99, 102, 241, 0.35)",
								fontFamily: "'Inter', sans-serif",
								"&:hover": {
									background:
										"linear-gradient(135deg, #5558E3 0%, #7C4DE8 100%)",
								},
							}}
						>
							Volver
						</Button>
					</>
				)}

				{status === "error" && (
					<>
						<Box
							sx={{
								width: 72,
								height: 72,
								borderRadius: "50%",
								background: "linear-gradient(135deg, #FEE2E2 0%, #FECACA 100%)",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								mx: "auto",
								mb: 3,
							}}
						>
							<ErrorOutlineIcon sx={{ fontSize: 40, color: "#DC2626" }} />
						</Box>
						<Typography
							sx={{
								fontSize: 22,
								fontWeight: 700,
								color: "#1a1a2e",
								mb: 1,
								fontFamily: "'Inter', sans-serif",
							}}
						>
							Error de verificación
						</Typography>
						<Typography
							sx={{
								fontSize: 14,
								color: "#64748b",
								mb: 3,
								lineHeight: 1.6,
								fontFamily: "'Inter', sans-serif",
							}}
						>
							{errorMsg}
						</Typography>
						<Button
							onClick={() => navigate("/")}
							sx={{
								height: 48,
								borderRadius: "14px",
								background: "linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
								color: "#fff!important",
								textTransform: "none",
								fontWeight: 600,
								fontSize: 14,
								px: 4,
								fontFamily: "'Inter', sans-serif",
								"&:hover": {
									background:
										"linear-gradient(135deg, #5558E3 0%, #7C4DE8 100%)",
								},
							}}
						>
							Volver
						</Button>
					</>
				)}
			</Box>
		</Box>
	);
};

export default VerifyEmailPage;
